<template>
  <div class="tab collapsed" :class="{open: open}">
    <div class="tabTitle" v-html="tab.title" @click="openTab"></div>
    <slide-up-down :active="open" :duration="500">
      <div class="portrait block" v-if="tab.image.src">
        <div class="aboutPortraitInner" :style="{paddingBottom: tab.image.ratio + '%'}" v-lazyload>
          <LazyImage :source="tab.image.src" :blur="tab.image.src_blur" />
          <div v-if="tab.image_credits" class="caption" v-html="tab.image_credits"></div>
        </div>
      </div>

      <div class="tabText" v-html="tab.text"></div>
    </slide-up-down>
  </div>
</template>

<script>
import SlideUpDown from 'vue-slide-up-down'
import LazyImage from '@/components/LazyImage.vue'

export default {
  data () {
    return {
      open: false
    }
  },

  components: {
    LazyImage,
    SlideUpDown
  },

  props: ['tab'],

  methods: {
    openTab () {
      this.open = !this.open
    }
  }
}
</script>
